<template>
  <div class="study-task-exam">
    <div class="wrapper">
      <div class="mask"></div>
      <div class="exam-title" v-show="question.description">
        <p>{{ question.description }}</p>
        <div
          class="cover"
          v-if="question.cover"
          :style="{ backgroundImage: 'url(' + question.cover + ')' }"
        >
          <div class="cover-mask"></div>
          <i class="icon"></i>
        </div>
      </div>
      <div class="examSubject">
        <template v-for="(sub, index) in question.subject" :key="index">
          <div v-if="sub.type === 'HTML' && sub.values[0]">
            <template v-for="(text, key) in sub.values" :key="key">
              <div v-html="text"></div>
            </template>
          </div>
          <div v-if="sub.type === 'IMAGE' && sub.values[0]" class="imgBox">
            <template v-for="(img, key) in sub.values" :key="key">
              <img :src="img" alt="" />
            </template>
          </div>
        </template>
      </div>
      <div class="exam-options" v-if="question.options">
        <div class="option" v-for="(value, key) in question.options" :key="key">
          <div class="optionsItemBox">
            <template v-for="(option, index) in value" :key="index">
              <div class="options-item" v-if="index === 0">
                <div class="radio">{{ key }}</div>
                <div
                  class="text-overflow info"
                  v-if="option.type === 'TEXT' && option.values[0]"
                >
                  <span v-for="(text, ind) in option.values" :key="ind">
                    {{ text }}
                  </span>
                </div>
                <div
                  v-else-if="option.type === 'HTML'"
                  class="text-overflow optionText info"
                >
                  <template v-for="(html, ind) in option.values" :key="ind">
                    <div v-html="html" class="text-overflow"></div>
                  </template>
                </div>
              </div>
              <div
                class="imgBox"
                v-if="option.type === 'IMAGE' && option.values[0]"
              >
                <img
                  v-for="(img, ind) in option.values"
                  :key="ind"
                  v-lazy="img"
                  alt=""
                />
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="exam-objective" v-else>
        <textarea placeholder="请输入答题内容"></textarea>
      </div>
    </div>

    <div class="footer">
      <p>答题进度：{{ question.position }}/{{ question.total }}</p>
      <button @click.stop="clickAction">立即练习</button>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { hostPath } from '@utils/basePath'
import { appPort, jumpModuleApp, queryToString } from '@/widget/index'
import { useRoute, useRouter } from 'vue-router'
const router = useRouter()
const route = useRoute()
const props = defineProps({
  question: {
    type: Object,
    default: () => {
      return {}
    }
  },
  taskId: {
    type: String
  }
})

const clickAction = () => {
  let routeQuery = route.query
  let query = {
    taskId: props.taskId
  }
  if (routeQuery.depId) {
    query.depId = routeQuery.depId
  }
  if (routeQuery.sourceId) {
    query.sourceId = routeQuery.sourceId
  }
  if (appPort()) {
    jumpModuleApp({
      typeId: 'h5',
      url: `${hostPath}/learn/detail/exercise/${
        props.question.paperId
      }?${queryToString(query)}`
    })
    app.postMessage({
      type: 'h5',
      url: `${hostPath}/learn/detail/exercise/${
        props.question.paperId
      }?${queryToString(routeQuery)}`
    })
  } else {
    router.push({
      path: `/detail/exercise/${props.question.paperId}`,
      query: {
        ...query,
        ...routeQuery
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.study-task-exam {
  position: relative;

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 1.1rem;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 90%);
    z-index: 1;
  }
  .footer {
    position: relative;
    width: 500px;
    margin-left: 18px;
    z-index: 2;
    p {
      color: #969799;
      font-size: 24px;
      margin-bottom: 10px;
    }
    button {
      width: 176px;
      height: 72px;
      border-radius: 36px;
      // border: 2px solid #FF6600;
      color: #ff6600;
      font-size: 28px;
      background-color: #fff;
      margin: 0 auto;
      display: block;
      border: none;
      background: #f5f5f7;
    }
  }
  .wrapper {
    overflow: hidden;
    max-height: 400px;
    margin-bottom: 15px;
    .exam-title {
      margin-bottom: 40px;
      p {
        color: #626366;
        font-size: 28px;
        line-height: 44px;
        height: 132px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .cover {
        width: 368px;
        height: 206px;
        margin: 30px auto 0;
        background-size: 100% auto;
        border-radius: 12px;
        position: relative;
        &-mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 12px;
          background-color: rgba(0, 0, 0, 0.4);
        }
        .icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: inline-block;
          width: 62px;
          height: 60px;
          background-image: url('../../img/video_play.png');
          background-size: cover;
        }
      }
    }
    .examSubject {
      font-size: 28px;
      color: #626366;
      line-height: 42px;
      margin-bottom: 40px;
      .imgBox {
        width: 368px;
        height: 206px;
        margin: 30px auto 10px;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
    }
    .exam-options {
      width: 500px;
      margin-left: 18px;
      .option {
        .options-item {
          /*height: 72px;*/
          line-height: 38px;
          background-color: #f5f5f7;
          border-radius: 8px;
          margin-bottom: 44px;
          color: #212224;
          font-size: 28px;
          padding: 15px 16px;
          display: flex;
          overflow: hidden;
          align-items: center;
          .radio {
            display: inline-block;
            width: 40px;
            height: 40px;
            overflow: hidden;
            line-height: 40px;
            text-align: center;
            background: rgba(255, 255, 255, 0);
            border-radius: 8px;
            border: 4px solid #b1b1b3;
            margin-right: 24px;
          }
          .info {
            flex: 0.92;
          }
          .optionText {
            height: 72px;
            overflow: hidden;
          }
        }
      }
      .imgBox {
        img {
          width: 374px;
          display: block;
          margin: 0 auto 30px;
          border-radius: 12px;
        }
      }
    }

    .exam-objective {
      textarea {
        width: 500px;
        height: 200px;
        background: #ffffff;
        border-radius: 8px;
        border: 2px solid #e1e2e6;
      }
    }
  }
}
</style>
